module.exports = __webpack_public_path__ + "img/eight5Blue.339f36ab.jpg";